import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../components/Reveal';
import { programmes } from '../data/siteData';
import IMG from '../data/images';

const imgs = [IMG.kidsPlaying, IMG.kidsArt, IMG.kidsNature, IMG.kidsReading, IMG.classroom];

const Programmes = () => (
  <div>
    <section style={{ paddingTop: 130, paddingBottom: 70, background: 'linear-gradient(135deg,var(--navy),var(--navy-dark))', textAlign: 'center' }}>
      <h1 style={{ fontFamily: 'var(--fh)', fontSize: '2.6rem', color: '#fff' }}>Our <span style={{ color: 'var(--gold)' }}>Programmes</span></h1>
      <p style={{ color: 'rgba(255,255,255,0.6)', maxWidth: 500, margin: '12px auto 0', lineHeight: 1.8 }}>Age-appropriate Finnish-inspired journeys — from toddlers to kindergarteners.</p>
    </section>

    <section style={{ padding: '90px 24px' }}>
      <div className="container">
        <Reveal><div className="gold-bar" /><h2 className="sec-heading">Choose Your Child's Path</h2><p className="sec-sub">Every programme is designed around Finland's core belief: children learn best when happy, safe, and free.</p></Reveal>
        {programmes.map((p, i) => (
          <Reveal key={p.id} delay={0.05}>
            <div className="card" style={{ display: 'grid', gridTemplateColumns: i % 2 === 0 ? '1fr 1.6fr' : '1.6fr 1fr', gap: 36, alignItems: 'center', padding: '36px 32px', marginBottom: 32 }} id={`prog-${p.id}`}>
              {i % 2 !== 0 && <div>
                <h3 style={{ fontFamily: 'var(--fh)', fontSize: '1.4rem', color: 'var(--navy)', marginBottom: 6 }}>{p.name}</h3>
                <div style={{ color: 'var(--gold)', fontWeight: 700, fontSize: '0.82rem', marginBottom: 14 }}>{p.age}</div>
                <p style={{ color: 'var(--body)', lineHeight: 1.9, marginBottom: 18, fontSize: '0.93rem' }}>{p.full}</p>
                {p.highlights.map((h, j) => <div key={j} style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'var(--navy)', fontSize: '0.86rem', marginBottom: 6 }}><span style={{ color: 'var(--gold)', fontWeight: 700 }}>✓</span>{h}</div>)}
              </div>}
              <div style={{ borderRadius: 16, overflow: 'hidden', height: 280 }}>
                <img src={imgs[i]} alt={p.name} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s' }} onMouseEnter={e => e.target.style.transform='scale(1.05)'} onMouseLeave={e => e.target.style.transform='scale(1)'} />
              </div>
              {i % 2 === 0 && <div>
                <h3 style={{ fontFamily: 'var(--fh)', fontSize: '1.4rem', color: 'var(--navy)', marginBottom: 6 }}>{p.name}</h3>
                <div style={{ color: 'var(--gold)', fontWeight: 700, fontSize: '0.82rem', marginBottom: 14 }}>{p.age}</div>
                <p style={{ color: 'var(--body)', lineHeight: 1.9, marginBottom: 18, fontSize: '0.93rem' }}>{p.full}</p>
                {p.highlights.map((h, j) => <div key={j} style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'var(--navy)', fontSize: '0.86rem', marginBottom: 6 }}><span style={{ color: 'var(--gold)', fontWeight: 700 }}>✓</span>{h}</div>)}
              </div>}
            </div>
          </Reveal>
        ))}
      </div>
    </section>
    <section style={{ padding: '70px 24px', background: 'var(--gold)', textAlign: 'center' }}>
      <h2 style={{ fontFamily: 'var(--fh)', fontSize: '2rem', color: 'var(--navy)', marginBottom: 14 }}>Not Sure Which Programme?</h2>
      <Link to="/contact" className="btn btn-navy">Talk to Us</Link>
    </section>
    <style>{`@media(max-width:768px){[id^="prog-"]{grid-template-columns:1fr!important;}}`}</style>
  </div>
);
export default Programmes;
